module.exports = __webpack_public_path__ + "static/media/4-kreatywne-pomysły-na-ferie-w-domu.c64d75e8.png";